import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { ReactComponent as AlertIcon } from '../../../../assets/images/alert-circle.svg';
import CourierDetailsGrid from './courierDetailsGrid';
export var ResendToASMPopup = function (_ref) {
    var onClose = _ref.onClose;
    var CourierDetailsElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            p: 1.5,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'dealer',
                    label: 'Deailer ID',
                    placeholder: 'select dealer ID',
                    columnSize: 12
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'Booking date',
                    label: 'Booking date',
                    columnSize: 12
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Docket number',
                    label: 'Docket number',
                    columnSize: 12
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'No. of sample',
                    label: 'No. of sample',
                    placeholder: 'Enter sample no..',
                    columnSize: 12
                }]
        }];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                                height: '20px',
                                width: '20px'
                            }),
                            columnSize: 0,
                            sx: {
                                bgcolor: 'warning.100',
                                cursor: 'default',
                                padding: '12px',
                                color: 'warning.500',
                                ':hover': {
                                    bgcolor: 'warning.100'
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Msg',
                    label: "Are you sure you want to Resend to ASM?",
                    value: null,
                    columnSize: 12,
                    children: "Actions taken cannot be undone.",
                    labelTypographyProps: {
                        fontSize: "xl",
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'secondary.600'
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    label: 'Priority',
                    placeholder: 'E.g. A-Loss of function'
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Resend reason',
                    label: 'Resend reason',
                    columnSize: 12,
                    multiline: true,
                    minRows: 4,
                    placeholder: 'Enter a description'
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    border: '1px solid',
                    borderColor: 'secondary.200',
                    borderRadius: '12px',
                    p: 1.5,
                    rowGap: 1.5,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            containerProps: {
                                spacing: 0
                            },
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            sx: {
                                border: 'none',
                                p: 0
                            },
                            contentProps: {
                                spacing: 0,
                                gap: '8px'
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Courier details',
                                    fontWeight: 'strong',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.CardComponent,
                                    name: '',
                                    columnSize: 12,
                                    containerProps: {
                                        m: 0
                                    },
                                    sx: {
                                        padding: '12px 16px',
                                        bgcolor: 'secondary.50',
                                        border: 'none'
                                    },
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 12,
                                            label: 'Previously submitted samples:',
                                            children: '2',
                                            fontSize: 'sm',
                                            fontWeight: 'medium'
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            spacing: 0,
                            alignItems: 'end',
                            sx: {
                                paddingLeft: {
                                    xs: 0,
                                    sm: '12px',
                                    md: '12px'
                                }
                            },
                            elements: [{
                                    type: FormItemTypes.Attachment,
                                    name: "Courier attachment",
                                    value: null,
                                    label: 'Courier attachment',
                                    columnSize: 12
                                }]
                        }, isMobile ? {
                            type: FormItemTypes.SearchSelect,
                            name: 'CourierDetails',
                            clearText: 'Clear Selected ',
                            label: 'Courier name',
                            placeholder: 'Select team member',
                            valueExpr: 'id',
                            columnSize: true
                        } : null, isMobile ? {
                            type: FormItemTypes.List,
                            name: 'CourierDetailsList',
                            value: [{
                                    id: 1
                                }, {
                                    id: 2
                                }],
                            columnSize: 12,
                            disableCheckboxSelection: true,
                            variant: 'compact',
                            cellStyles: {
                                bgcolor: 'background.secondary'
                            },
                            columns: [{
                                    field: 'complaints',
                                    flex: 1,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        }, "Courier_1"), /*#__PURE__*/ React.createElement(Typography, {
                                            color: 'text.tertiary',
                                            fontSize: 'sm'
                                        }, "17 Oct, 2020 "));
                                    }
                                }],
                            elements: CourierDetailsElements
                        } : null]
                }, !isMobile ? {
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: CourierDetailsGrid
                } : null, {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'PSG remarks',
                    columnSize: 12,
                    multiline: true,
                    minRows: 4,
                    placeholder: 'Enter a description'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    },
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Confirm',
                    onClick: function () {
                        onClose('confirm');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
